import { Box, Text, Loader, Grid, Paper, Stack } from '@mantine/core';
import { apiInstance } from '../../services/api_service';
import { useEffect, useState, useCallback } from 'react';
import { getRelationship } from '../../utils/utils';

const GuardiansList = ({ row }) => {
  const studentId = row.original.id;
  const [isLoading, setIsLoading] = useState(false);
  const [guardians, setGuardians] = useState([]);

  const fetchGuardians = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiInstance.get(`/students/${studentId}/guardians/`);
      setGuardians(response.data.results);
    } catch (error) {
      console.error('Error fetching guardians:', error);
    } finally {
      setIsLoading(false);
    }
  }, [studentId]);

  useEffect(() => {
    fetchGuardians();
  }, [fetchGuardians]);

  return (
    <Box 
      sx={{ 
        width: '100%', 
      }}
    >
      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px' }}>
          <Loader size="sm" />
        </Box>
      ) : guardians.length > 0 ? (
                          <Paper 
          withBorder 
          p="xs" 
          radius="md"
        >
            {/* Header - Hidden on mobile */}
            <Grid 
              sx={{
                borderBottom: '1px solid #e9ecef',
                paddingBottom: '6px',
                marginBottom: '6px',
                '@media (max-width: 768px)': {
                  display: 'none',
                }
              }}
            >
              <Grid.Col span={6}>
                <Text weight={500} size="sm">Nome / Parentesco</Text>
              </Grid.Col>
              <Grid.Col span={6}>
                <Text weight={500} size="sm">Telefone / Email</Text>
              </Grid.Col>
            </Grid>

            {/* Guardians List */}
            <Box>
              <Stack spacing="xs">
                {guardians.map((guardian, index) => (
                <Box key={index}>
                  {/* Desktop Layout - Simplified 2 columns */}
                                      <Grid 
                      sx={{
                        borderTop: index > 0 ? '1px solid #f1f3f4' : 'none',
                        paddingTop: index > 0 ? '8px' : '0',
                        '@media (max-width: 768px)': {
                          display: 'none',
                        }
                      }}
                    >
                    <Grid.Col span={6}>
                      <Stack spacing={2}>
                        <Text size="sm" weight={500}>{guardian.name}</Text>
                        <Text size="xs" color="dimmed">{getRelationship(guardian.relationship)}</Text>
                      </Stack>
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <Stack spacing={2}>
                        <Text size="sm">{guardian.cellphone || guardian.phone || 'N/A'}</Text>
                        <Text size="xs" color="dimmed">{guardian.email || 'N/A'}</Text>
                      </Stack>
                    </Grid.Col>
                  </Grid>

                  {/* Mobile Layout - Card format */}
                  <Box 
                    sx={{
                      display: 'none',
                      '@media (max-width: 768px)': {
                        display: 'block',
                        padding: '16px',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '8px',
                        marginBottom: '8px',
                        border: '1px solid #e9ecef',
                      }
                    }}
                  >
                    <Stack spacing={8}>
                      {/* Nome e Parentesco */}
                      <Box>
                        <Text size="sm" weight={500} mb={4}>{guardian.name}</Text>
                        <Text size="xs" color="dimmed">{getRelationship(guardian.relationship)}</Text>
                      </Box>
                      
                      {/* Telefone e Email */}
                      <Box>
                        <Text size="sm" mb={4}>{guardian.cellphone || guardian.phone || 'N/A'}</Text>
                        <Text size="xs" color="dimmed">{guardian.email || 'N/A'}</Text>
                      </Box>
                    </Stack>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Box>
        </Paper>
      ) : (
        <Box 
          sx={{ 
            padding: '12px',
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            border: '1px dashed #dee2e6',
            borderRadius: '8px',
            backgroundColor: '#f8f9fa',
          }}
        >
          <Text size="sm" color="gray" style={{ fontStyle: 'italic' }}>
            Nenhum responsável encontrado
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default GuardiansList;
